import { InfoCircleFilled } from '@creditornot/cb-icons';
import { InputSwitch } from '@creditornot/cb-switch';
import React from 'react';

import * as S from './SettingRow.styles';

type SettingRowProps = {
  checked: boolean;
  description: string;
  disableToggling: boolean;
  hint?: string;
  onToggle: () => void;
  title: string;
};

export const SettingRow = ({ description, disableToggling, hint, title, checked, onToggle }: SettingRowProps) => {
  return (
    <S.Root>
      <S.SettingInfo>
        <S.SettingTitle>{title}</S.SettingTitle>
        <S.SettingDescription>{description}</S.SettingDescription>
        {hint && (
          <S.SettingHint>
            <InfoCircleFilled />
            {hint}
          </S.SettingHint>
        )}
      </S.SettingInfo>
      <InputSwitch disabled={disableToggling} checked={checked} onChange={onToggle} />
    </S.Root>
  );
};
